<tt-field-group class="tt-c-added-media"
                describedbyId="tt-add-media-desc"
                :label="label"
                :hintText="$msg('addedMedia.addMediaInfo')"
                :errorText="errorText">
  <div v-if="media && media.length > 0" class="tt-c-added-media__items">
    <div v-for="mediaItem in media" class="tt-c-added-media__card">
      <div class="tt-c-added-media__item">
        <tt-media-submission-thumb v-if="!mediaItem.imageProcessed"
          class="tt-c-added-media__item-image"
          :altText="mediaItem.altText"
          :media="mediaItem" 
          :size="mediaSize"></tt-media-submission-thumb>
        <tt-media-thumb v-if="mediaItem.imageProcessed"
          class="tt-c-added-media__item-image"
          :altText="mediaItem.altText"
          :media="mediaItem" 
          :size="mediaSize"></tt-media-thumb>
      </div>
      <div class="tt-c-added-media__caption" :class="{'tt-c-added-media__caption--quoted': mediaItem.text}">{{mediaItem.captionText}}<template v-if="mediaItem.isTruncated">&hellip;</template></div>
      <button type="button"
                class="tt-c-added-media__remove tt-o-button--action-icon-chip"
                @click.prevent="removeMedia(mediaItem)"
                :aria-label="mediaItem.removeMsg">
        <tt-icon class="tt-c-added-media__remove-icon" name="close" size="xxs"></tt-icon>
      </button>
    </div>
  </div>
  <div class="tt-c-added-media__buttons">
    <div class="tt-c-added-media__upload-wrapper">
      <label class="tt-c-added-media__add-photo" for="tt-add-photos-input">
        <tt-button ref="addPhotoBtn" type="tertiary" class="tt-c-added-media__add-photo-btn" @click.prevent="triggerAddPhotos" :aria-describedby="btnDescribedby" :disabled="hasMaxMedia"><tt-icon name="photo" size="sm"></tt-icon> <span v-html="addPhotoTxt"></span></tt-button>
      </label>
      <input v-show="false" id="tt-add-photos-input" ref="addPhotosInput" type="file" @change="addPhotos" name="tt-add-photos-input" :accept="supportedImageTypes" multiple="" :disabled="hasMaxMedia" tabindex="-1">
    </div>
    <tt-button type="tertiary" @click="addVideo" class="tt-c-added-media__add-video" :aria-describedby="btnDescribedby" :disabled="hasMaxMedia"><tt-icon name="video" size="sm"></tt-icon><span v-html="addVideoTxt"></span></tt-button>
  </div>
</tt-field-group>
  